// @ts-nocheck
/* eslint-disable */
export const arrowUpIcon = {
  data: `<svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.66673 5.71928V13.8337H7.33339V5.71928L3.75742 9.29526L2.81461 8.35246L8.00006 3.16699L13.1855 8.35246L12.2427 9.29526L8.66673 5.71928Z" fill="currentColor"/></svg>`,
  name: 'arrow-up' as const,
};
